import { render, staticRenderFns } from "./ProjectAreaByRegion.vue?vue&type=template&id=2b222fef&scoped=true&lang=pug&"
import script from "./ProjectAreaByRegion.vue?vue&type=script&lang=js&"
export * from "./ProjectAreaByRegion.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAreaByRegion.vue?vue&type=style&index=0&id=2b222fef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b222fef",
  null
  
)

export default component.exports